"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppManifest = void 0;
function getAppManifest(state) {
    var _a;
    if (((_a = state.appManifest.appManifest) === null || _a === void 0 ? void 0 : _a.status) === 'done') {
        if (state.appManifest.appManifest.data) {
            return state.appManifest.appManifest.data;
        }
        else {
            throw new Error('Invalid app manifest state, data is not set.');
        }
    }
    else {
        throw new Error('App manifest is not loaded.');
    }
}
exports.getAppManifest = getAppManifest;
